import type { PropsWithChildren } from 'react';
import { Heading2, Heading3 } from '../../Text';
import { Wrapper, Answer } from './EmbeddedFaqItem.styles';

type EmbeddedFaqItemHeadingLevel = 'h2' | 'h3';

type EmbeddedFaqItemProps = PropsWithChildren<{
  question: string;
  headingLevel?: EmbeddedFaqItemHeadingLevel;
}>;

/**
 * Renders a single FAQ item embedded directly in article rich text, as
 * opposed to one rendered as part of the FAQ module's accordion. There is no
 * parent module here to toggle visibility, so question and answer are always
 * shown and there is no collapse affordance.
 *
 * The question gets no `content-headline-N` anchor id, also as h2. A counted
 * h2 would move the number of each later h2 in the text and break existing
 * anchor links to them.
 */
const EmbeddedFaqItem = ({
  question,
  headingLevel = 'h3',
  children,
}: EmbeddedFaqItemProps) => {
  const Heading = headingLevel === 'h2' ? Heading2 : Heading3;

  return (
    <Wrapper>
      <Heading textColor="current">{question}</Heading>
      <Answer>{children}</Answer>
    </Wrapper>
  );
};

export { EmbeddedFaqItem };
export type { EmbeddedFaqItemProps, EmbeddedFaqItemHeadingLevel };
